import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { IconButton, Menu, MenuItem, Divider, Avatar, Typography } from '@mui/material'
import { Person as PersonIcon } from '@mui/icons-material'
import { useAuthStore } from '../stores/authStore'
import { queryClient } from '../api/queryClient'
import api from '../api/client'

export default function UserMenu() {
  const { user, logout } = useAuthStore()
  const navigate = useNavigate()
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)

  const handleOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const handleLogout = async () => {
    // If user logged in via OIDC, check for IdP end-session URL
    if (user?.authMethod === 'oidc') {
      try {
        const res = await api.post('/auth/sso/logout')
        if (res.data.logout_url) {
          logout()
          queryClient.clear()
          window.location.href = res.data.logout_url
          return
        }
      } catch {
        // Fall through to local logout
      }
    }
    logout()
    queryClient.clear()
    navigate('/login')
    handleClose()
  }

  return (
    <>
      <IconButton color="inherit" onClick={handleOpen}>
        <Avatar sx={{ width: 32, height: 32, bgcolor: 'primary.main', fontSize: '0.875rem' }}>
          {user?.username?.charAt(0).toUpperCase() || <PersonIcon fontSize="small" />}
        </Avatar>
      </IconButton>
      <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleClose}>
        <MenuItem disabled sx={{ opacity: '1 !important', cursor: 'default' }}>
          <Typography variant="body2" fontWeight={600}>
            {user?.username || 'Guest'}
          </Typography>
        </MenuItem>
        <Divider />
        <MenuItem onClick={() => { navigate('/settings'); handleClose() }}>Settings</MenuItem>
        <MenuItem onClick={handleLogout}>Sign out</MenuItem>
      </Menu>
    </>
  )
}